import { AbstractExpressionItem } from "./AbstractExpressionItem";
import { TypeKeys } from "./TypeKeys";
import { CalculateKinds } from "../CalculateKinds";
import { ICalculatedValueValidatable } from "./ICalculatedValueValidatable";
import { IValueForCalculateExtractable } from "./IValueForCalculateExtractable";
import { TimeSpan } from "../../../domain/system";
import { NumericFormatKinds, NumericInputFormatter } from "..";
import { DataValidationKinds } from "../DataValidationKinds";
import { ITextValidatable } from "./ITextValidatable";
import { INaturalTextSpecifiable } from "./INaturalTextSpecifiable";
import { ICompareDateValidatable } from "./ICompareDateValidatable";

export class CalculateItem extends AbstractExpressionItem implements ICalculatedValueValidatable, IValueForCalculateExtractable, ITextValidatable, INaturalTextSpecifiable, ICompareDateValidatable {
  constructor(value: any) {
    super(TypeKeys.CalculateItem, value);
  }

  public dataValidationKind: DataValidationKinds = null;
  public calculateKind: CalculateKinds = null;
  public numericFormat: NumericFormatKinds = NumericFormatKinds.Invalid;
  public isNaturalViewEnable: boolean;
  public naturalText: string;
  public isCompareDateEmptyCheckEnable: boolean;

  protected createCloneInstance(): CalculateItem {
    return new CalculateItem(this.originalValue);
  }

  protected applyMembers(clone: CalculateItem): void {
    super.applyMembers(clone);
    clone.dataValidationKind = this.cloneValue(this.dataValidationKind);
    clone.calculateKind = this.cloneValue(this.calculateKind);
    clone.numericFormat = this.cloneValue(this.numericFormat);
    clone.isNaturalViewEnable = this.cloneValue(this.isNaturalViewEnable);
    clone.naturalText = this.cloneValue(this.naturalText);
    clone.isCompareDateEmptyCheckEnable = this.cloneValue(this.isCompareDateEmptyCheckEnable);
  }

  /**
   * 経過時間の結果が「**分」といった文字列になっていて計算できないので、暫定対策として分の数にパースする
   * 金額表示のカンマについても同様に暫定対策している
   */
  extractValueForCalculate(): any {
    const isPeriodTime = this.calculateKind === CalculateKinds.PeriodTime;
    const isMoneyFormat = this.numericFormat === NumericFormatKinds.Money;
    return this.shouldInputFree ? this.value
      : isPeriodTime ? this.toMinutes(this.value)
      : isMoneyFormat ? NumericInputFormatter.toDigit(this.value)
      : this.value;
  }

  private toMinutes(value: any): any {
    if (value === null || value === undefined || typeof(value) !== "string") { return value; }
    return TimeSpan.toMinutesFromText(value);
  }

  get isCalculatedValueEmpty(): boolean {
    // 条件式は計算した結果、空文字になることがある
    if (this.calculateKind === CalculateKinds.Conditional) { return false; }
    // 日付比較はCompareDateValidatorで空の場合のチェックしている
    if (this.calculateKind === CalculateKinds.CompareDate) { return false; }
    return this.isEmpty;
  }

  getDisplayName(): string {
    return this.name;
  }

  shouldValidateText(): boolean {
    return this.isFreeInputable && this.shouldInputFree;
  }

  protected toFormattedValue(value: any): any {
    if (this.numericFormat === NumericFormatKinds.Money) {
      if (this.shouldInputFree || value === undefined || value === null) { return value; }
      const text = this.valueToText(value);
      return NumericInputFormatter.format(text, this.numericFormat);
    }
    return value;
  }

  protected getRangeValidateValue(): any {
    return ((this.numericFormat === NumericFormatKinds.Money) && !!this.value && (typeof this.value === "string"))
      ? this.value.replace(/,/g, "")
      : this.value;
  }

  get currentNaturalText(): string {
    return this.isNaturalViewEnable && this.naturalText
      ? this.naturalText
      : this.text();
  }
}
